<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <TsMenuButton ref='tsMenuButton' @methodEnum='methodEnum' ></TsMenuButton>
      <div class="h100-140 h-scroll" style="padding-top: 30px;">
        <DailyActivityChart ref='dailyActivityChart'></DailyActivityChart>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import TsMenuButton from '../../components/tsConfig/TsMenuButton';
import DailyActivityChart from '../../components/tsConfig/DailyActivityStatistics/DailyActivityChart';

export default {
  name: 'DailyActivityStatisticsPage',
  components: {
    BasicLayout,
    TsMenuButton,
    DailyActivityChart
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('TS.registerServiceStatistics')}/${this.$t('TS.dailyActivityStatistics')}`
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.dailyActivityChart.searchPage();
          break;
        default:
      }
    }
  }
};
</script>

<style scoped>

</style>
